import { Typography, useMediaQuery } from "@mui/material";
import { EditableDataGrid } from "../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { RowModeIds } from "../../../builderPackage/components/editableDataGrid/editableDataGrid.entity";
import { MuiStack } from "../../../components";
import { systemColor } from "../../../theme/systemColor";
import { AccountPostingMobile } from "./jciReturnAccountPostingMobile";
export var JciAccountPosting = function (props) {
    var onChange = props.onChange, value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? 'partDetails' : _a;
    var currValue = value[name];
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var accountPostingColumn = [{
            field: 'Account',
            headerName: 'Account',
            width: 224,
            headerAlign: 'left',
            disableColumnMenu: true,
            renderCell: function (params) {
                if ((params === null || params === void 0 ? void 0 : params.id) === RowModeIds.Aggregation) {
                    return 'Total';
                }
                else {
                    var _params$row, _params$row2;
                    return /*#__PURE__*/ React.createElement(MuiStack, {
                        direction: 'column'
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        variant: "caption"
                    }, params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.Account), /*#__PURE__*/ React.createElement(Typography, {
                        color: systemColor.lightGrey,
                        variant: "caption"
                    }, params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.code));
                }
            }
        }, {
            field: 'DebitAmount',
            headerName: 'Debit Amount (₹)',
            width: 249.5,
            headerAlign: 'left',
            disableColumnMenu: true,
            type: 'number'
        }, {
            field: 'CreditAmount',
            headerName: 'Credit Amount (₹)',
            width: 249.5,
            headerAlign: 'left',
            disableColumnMenu: true,
            type: 'number'
        }, {
            field: 'Remark',
            headerName: 'Remark',
            width: 580,
            headerAlign: 'left',
            disableColumnMenu: true
        }];
    return isMobile ? /*#__PURE__*/ React.createElement(AccountPostingMobile, null) : /*#__PURE__*/ React.createElement(EditableDataGrid, {
        dataGridHeader: "Posting Details",
        isCollapsible: true,
        columns: accountPostingColumn,
        dataGridProps: {
            checkboxSelection: false,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            initialState: {
                aggregation: {
                    model: {
                        DebitAmount: 'sum',
                        CreditAmount: 'sum'
                    }
                }
            }
        },
        disableAddRow: true,
        disableDeleteRow: true
        // rows={currValue || []}
        ,
        onChange: onChange,
        error: error === null || error === void 0 ? void 0 : error[name],
        rows: [{
                "id": 1,
                "Account": "purchase 1",
                "code": "#1234",
                "DebitAmount": 100,
                "CreditAmount": 100,
                "Remark": "Test"
            }, {
                "id": 2,
                "Account": "purchase 2",
                "code": "#1234",
                "DebitAmount": 200,
                "CreditAmount": 150,
                "Remark": "Test 2"
            }, {
                "id": 3,
                "Account": "purchase 3",
                "code": "#1234",
                "DebitAmount": 300,
                "CreditAmount": 0,
                "Remark": "Test 3"
            }, {
                "id": 4,
                "Account": "purchase 4",
                "code": "#1234",
                "DebitAmount": 0,
                "CreditAmount": 400,
                "Remark": "Test 4"
            }]
    });
};
